import { render, staticRenderFns } from "./TeacherHeader.vue?vue&type=template&id=2eae412e&"
import script from "./TeacherHeader.vue?vue&type=script&lang=js&"
export * from "./TeacherHeader.vue?vue&type=script&lang=js&"
import style0 from "./TeacherHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports